export default __webpack_public_path__ + "static/media/nft6.c1f129e0.png";